// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Coin List Details – section card + table + modal */
.coinlist-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.coinlist-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.coinlist-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.coinlist-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.coinlist-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.coinlist-section__stats {
  display: flex;
  gap: 1.25rem;
}

.coinlist-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.coinlist-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.coinlist-table-wrap {
  overflow-x: auto;
}

.coinlist-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.coinlist-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.coinlist-table th {
  padding: 1rem 1.25rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.coinlist-table td {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.coinlist-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.coinlist-table tbody tr:hover {
  background: #f0fdfa !important;
}

.coinlist-table tbody tr:last-child td {
  border-bottom: none;
}

/* Status badges */
.coinlist-status {
  display: inline-block;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}

.coinlist-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.coinlist-status--approved {
  background: #dcfce7;
  color: #166534;
}

.coinlist-status--rejected {
  background: #f1f5f9;
  color: #64748b;
}

/* Action buttons */
.coinlist-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.coinlist-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s, background 0.2s;
}

.coinlist-btn--view {
  background: #e0f2fe;
  color: #0369a1;
}

.coinlist-btn--view:hover {
  background: #0ea5e9;
  color: #fff;
}

.coinlist-btn--approve {
  background: #dcfce7;
  color: #166534;
}

.coinlist-btn--approve:hover {
  background: #16a34a;
  color: #fff;
}

.coinlist-btn--reject {
  background: #fef2f2;
  color: #b91c1c;
}

.coinlist-btn--reject:hover {
  background: #dc2626;
  color: #fff;
}

.coinlist-btn--secondary {
  background: #f1f5f9;
  color: var(--text);
}

.coinlist-btn--secondary:hover {
  background: #e2e8f0;
}

/* Modal */
.coinlist-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.coinlist-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 520px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.coinlist-modal__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  position: relative;
}

.coinlist-modal__header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  flex: 1 1;
  min-width: 0;
}

.coinlist-modal__header .coinlist-status {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.coinlist-modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
}

.coinlist-modal__close:hover {
  background: rgba(255, 255, 255, 0.35);
}

.coinlist-modal__body {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
}

.coinlist-dl {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.85rem;
}

.coinlist-dl div {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 0.75rem;
  align-items: start;
}

.coinlist-dl dt {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-muted);
}

.coinlist-dl dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text);
  word-break: break-word;
}

.coinlist-dl__mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #475569;
}

.coinlist-modal__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border);
  background: #f8fafc;
}

@media (max-width: 600px) {
  .coinlist-dl div {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/CoinListDetailsPage.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Coin List Details – section card + table + modal */\n.coinlist-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.coinlist-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.coinlist-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.coinlist-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.coinlist-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.coinlist-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.coinlist-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.coinlist-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.coinlist-table-wrap {\n  overflow-x: auto;\n}\n\n.coinlist-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.coinlist-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.coinlist-table th {\n  padding: 1rem 1.25rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.coinlist-table td {\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.coinlist-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.coinlist-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.coinlist-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Status badges */\n.coinlist-status {\n  display: inline-block;\n  padding: 0.35rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.coinlist-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.coinlist-status--approved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.coinlist-status--rejected {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n/* Action buttons */\n.coinlist-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.coinlist-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s, background 0.2s;\n}\n\n.coinlist-btn--view {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.coinlist-btn--view:hover {\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.coinlist-btn--approve {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.coinlist-btn--approve:hover {\n  background: #16a34a;\n  color: #fff;\n}\n\n.coinlist-btn--reject {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.coinlist-btn--reject:hover {\n  background: #dc2626;\n  color: #fff;\n}\n\n.coinlist-btn--secondary {\n  background: #f1f5f9;\n  color: var(--text);\n}\n\n.coinlist-btn--secondary:hover {\n  background: #e2e8f0;\n}\n\n/* Modal */\n.coinlist-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.coinlist-modal {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 520px;\n  width: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.coinlist-modal__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  position: relative;\n}\n\n.coinlist-modal__header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  flex: 1;\n  min-width: 0;\n}\n\n.coinlist-modal__header .coinlist-status {\n  background: rgba(255, 255, 255, 0.25);\n  color: #fff;\n}\n\n.coinlist-modal__close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.coinlist-modal__close:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.coinlist-modal__body {\n  padding: 1.25rem 1.5rem;\n  overflow-y: auto;\n}\n\n.coinlist-dl {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.85rem;\n}\n\n.coinlist-dl div {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 0.75rem;\n  align-items: start;\n}\n\n.coinlist-dl dt {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.coinlist-dl dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text);\n  word-break: break-word;\n}\n\n.coinlist-dl__mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #475569;\n}\n\n.coinlist-modal__footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border);\n  background: #f8fafc;\n}\n\n@media (max-width: 600px) {\n  .coinlist-dl div {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
